
import { defineComponent, ref } from 'vue'
import SbForm from '@/base-ui/form'
import { usePageSearch } from '@/hooks/use-page-search'
import { Search, Refresh } from '@element-plus/icons-vue'
export default defineComponent({
  components: {
    SbForm
  },
  props: {
    searchFormConfig: {
      type: Object,
      required: true
    }
  },
  emits: ['resetBtnClick', 'queryBtnClick'],
  setup(props, { emit }) {
    // 双向绑定的属性应该是由配置文件的field来决定
    // 1.优化一: formData中的属性应该动态来决定
    const formItems = props.searchFormConfig?.formItems ?? []
    const formOriginData: any = {}
    for (const item of formItems) {
      formOriginData[item.field] = ''
    }
    const formData = ref(formOriginData)

    // 2.优化二: 当用户点击重置
    const handleResetClick = () => {
      console.log(formOriginData)

      formData.value = formOriginData
      emit('resetBtnClick')
      //双向绑定实现
      // for (const key in formOriginData) {
      //   formData.value[`${key}`] = formOriginData[key]
      // }
    }
    // 3.优化三: 当用户点击搜索

    const handleQueryClick = () => {
      emit('queryBtnClick', formData.value)
    }
    return {
      formData,
      handleResetClick,
      handleQueryClick,
      Search,
      Refresh
    }
  }
})
